export const replacer = (reg: RegExp,sub:string,value?: string,) => {
  const result = value?.trim().replaceAll(reg, sub)
  return result;
};

export default replacer;
